import { Report } from './types';

const round = (value: number): number => Math.round(value * 100) / 100;

const transform = (values: number[][][]) => {
  let allAvgTotal = 0;
  let allCount = 0;
  let maleAvgTotal = 0;
  let maleCount = 0;
  let femaleAvgTotal = 0;
  let femaleCount = 0;
  let ruralAvgTotal = 0;
  let ruralCount = 0;
  let urbanAvgTotal = 0;
  let urbanCount = 0;
  let govtAvgTotal = 0;
  let govtCount = 0;
  let govtAidedAvgTotal = 0;
  let govtAidedCount = 0;
  let generalAvgTotal = 0;
  let generalCount = 0;
  let obcAvgTotal = 0;
  let obcCount = 0;
  let scAvgTotal = 0;
  let scCount = 0;
  let stAvgTotal = 0;
  let stCount = 0;
  let below30Count = 0;
  let between30And50Count = 0;
  let between50And75Count = 0;
  let above75Count = 0;
  for (const subEntity of values) {
    allAvgTotal += subEntity[0][0] * subEntity[0][1];
    allCount += subEntity[0][1];
    maleAvgTotal += subEntity[1][0] * subEntity[1][1];
    maleCount += subEntity[1][1];
    femaleAvgTotal += subEntity[2][0] * subEntity[2][1];
    femaleCount += subEntity[2][1];
    ruralAvgTotal += subEntity[3][0] * subEntity[3][1];
    ruralCount += subEntity[3][1];
    urbanAvgTotal += subEntity[4][0] * subEntity[4][1];
    urbanCount += subEntity[4][1];
    govtAvgTotal += subEntity[5][0] * subEntity[5][1];
    govtCount += subEntity[5][1];
    govtAidedAvgTotal += subEntity[6][0] * subEntity[6][1];
    govtAidedCount += subEntity[6][1];
    generalAvgTotal += subEntity[7][0] * subEntity[7][1];
    generalCount += subEntity[7][1];
    obcAvgTotal += subEntity[8][0] * subEntity[8][1];
    obcCount += subEntity[8][1];
    scAvgTotal += subEntity[9][0] * subEntity[9][1];
    scCount += subEntity[9][1];
    stAvgTotal += subEntity[10][0] * subEntity[10][1];
    stCount += subEntity[10][1];
    // below30Count += subEntity[11][0];
    // between30And50Count += subEntity[12][0];
    // between50And75Count += subEntity[13][0];
    // above75Count += subEntity[14][0];
  }
  const totalRecordsCount =
    below30Count + between30And50Count + between50And75Count + above75Count;
  const below30CountPercentage = round(
    (below30Count * 100) / totalRecordsCount
  );
  const between30And50CountPercentage = round(
    (between30And50Count * 100) / totalRecordsCount
  );
  const between50And75CountPercentage = round(
    (between50And75Count * 100) / totalRecordsCount
  );
  const above75CountPercentage = round(
    (above75Count * 100) / totalRecordsCount
  );
  return {
    total: round(allAvgTotal / allCount),
    male: round(maleAvgTotal / maleCount),
    female: round(femaleAvgTotal / femaleCount),
    rural: round(ruralAvgTotal / ruralCount),
    urban: round(urbanAvgTotal / urbanCount),
    govt: round(govtAvgTotal / govtCount),
    govtAided: round(govtAidedAvgTotal / govtAidedCount),
    general: round(generalAvgTotal / generalCount),
    obc: round(obcAvgTotal / obcCount),
    sc: round(scAvgTotal / scCount),
    st: round(stAvgTotal / stCount),
    below30: below30CountPercentage,
    between30And50: between30And50CountPercentage,
    between50And75: between50And75CountPercentage,
    above75: above75CountPercentage,
  };
};

const mapReport = (report: Report): Report => ({
  ...report,
  subjects: report.subjects.map((subject) => {
    const values = transform(subject.values);
    return {
      ...subject,
      barChartData: {
        total: {
          parameters: ['All'],
          values: [values.total],
        },
        gender: {
          parameters: ['Male', 'Female'],
          values: [values.male, values.female],
        },
        location: {
          parameters: ['Rural', 'Urban'],
          values: [values.rural, values.urban],
        },
        management: {
          parameters: ['Govt.', 'Govt. Aided'],
          values: [values.govt, values.govtAided],
        },
        socialGroup: {
          parameters: ['General', 'SC', 'ST', 'OBC'],
          values: [values.general, values.sc, values.st, values.obc],
        },
        percentageDistribution: {
          parameters: ['Below 30%', '30-50%', '50-75%', 'Above 75%'],
          values: [
            values.below30,
            values.between30And50,
            values.between50And75,
            values.above75,
          ],
        },
        subTypesBarChartData: {
          // eslint-disable-next-line  max-len
          parameters: [
            'All',
            'Male',
            'Female',
            'Rural',
            'Urban',
            'Govt.',
            'Govt. Aided',
            'General',
            'SC',
            'ST',
            'OBC',
          ],
          // eslint-disable-next-line  max-len
          values: [
            values.total,
            values.male,
            values.female,
            values.rural,
            values.urban,
            values.govt,
            values.govtAided,
            values.general,
            values.sc,
            values.st,
            values.obc,
          ],
        },
      },
    };
  }),
});

export default mapReport;
